// extracted by mini-css-extract-plugin
module.exports = {"page":"add_page_GKYzw","card-wrapper":"add_card-wrapper_9HR59","footer":"add_footer_1g-aF"};